var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaysafecard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Paysafecard",
    transform: "translate(-798.999 -735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5217",
    "data-name": "Rectangle 5217",
    width: 112,
    height: 56,
    transform: "translate(799 735)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "paysafecard-vector-logo",
    transform: "translate(798.999 753.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54783",
    "data-name": "Path 54783",
    d: "M98.5,302.013a3.064,3.064,0,0,1,.579-1.96,2.57,2.57,0,0,1,.728-.467,2.27,2.27,0,0,1,.9-.187h3.491c1.531.019,2.315.84,2.352,2.52v5.152a2.108,2.108,0,0,1-.709,1.531,2.273,2.273,0,0,1-1.587.709h-3.285v3.715H98.5Zm5.581.485c-.019-.392-.187-.579-.56-.6h-1.9a.691.691,0,0,0-.709.728v3.416a.687.687,0,0,0,.765.728h1.736a.539.539,0,0,0,.448-.205.447.447,0,0,0,.187-.392l.037-3.677Z",
    transform: "translate(-83.903 -294.024)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54784",
    "data-name": "Path 54784",
    d: "M157.763,302.443c.019-.373-.205-.56-.653-.541H152.2v-2.5h5.544a2.185,2.185,0,0,1,2.464,2.352v5.227a2.425,2.425,0,0,1-.6,1.643,2.089,2.089,0,0,1-1.587.691h-3.341c-1.624-.019-2.464-.747-2.483-2.24v-2.016a2.11,2.11,0,0,1,2.352-2.352H157.8l-.037-.261Zm-3.173,3.845a.355.355,0,0,0,.187.336.691.691,0,0,0,.448.168h1.867c.429,0,.653-.168.653-.485V305.6c0-.373-.224-.579-.672-.579h-1.848a.835.835,0,0,0-.5.112.91.91,0,0,0-.131.541v.616Z",
    transform: "translate(-127.579 -294.024)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54785",
    "data-name": "Path 54785",
    d: "M210.472,310.425a.764.764,0,0,0,.485-.205.5.5,0,0,0,.187-.411v-.579h-3.117a2.322,2.322,0,0,1-2.259-1.512,2.582,2.582,0,0,1-.168-1.008v-7.373h2.445v6.589c0,.541.205.8.653.8h1.717a.73.73,0,0,0,.541-.205.5.5,0,0,0,.205-.429V299.3h2.427v10.9a3.092,3.092,0,0,1-.616,1.941,2.061,2.061,0,0,1-1.661.747h-5.693v-2.5h4.853v.037Z",
    transform: "translate(-171.011 -293.943)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54786",
    "data-name": "Path 54786",
    d: "M258.6,306.711h4.349c.392-.019.6-.187.616-.467v-.224a.486.486,0,0,0-.056-.205c-.093-.187-.205-.28-.355-.28h-2.147a2.4,2.4,0,0,1-1.643-.653,1.9,1.9,0,0,1-.709-1.456V301.54c.037-1.475.821-2.2,2.371-2.24h5.04v2.5h-4.275c-.5,0-.747.149-.747.448v.261c0,.317.261.467.765.467h2.147a1.988,1.988,0,0,1,1.475.672,2.261,2.261,0,0,1,.635,1.531v1.829a2.355,2.355,0,0,1-.709,1.531,1.934,1.934,0,0,1-.691.523,2.652,2.652,0,0,1-.952.131h-5.1l-.019-2.483Z",
    transform: "translate(-214.117 -293.943)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54787",
    "data-name": "Path 54787",
    d: "M313.563,302.443c.019-.373-.205-.56-.653-.541H308v-2.5h5.544a2.185,2.185,0,0,1,2.464,2.352v5.227a2.424,2.424,0,0,1-.6,1.643,2.089,2.089,0,0,1-1.587.691h-3.341c-1.624-.019-2.464-.747-2.483-2.24v-2.016a2.11,2.11,0,0,1,2.352-2.352H313.6l-.037-.261Zm-3.173,3.845a.355.355,0,0,0,.187.336.691.691,0,0,0,.448.168h1.867c.429,0,.635-.168.653-.485V305.6c0-.373-.224-.579-.672-.579h-1.848a.835.835,0,0,0-.5.112.909.909,0,0,0-.131.541v.616Z",
    transform: "translate(-254.296 -294.024)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54788",
    "data-name": "Path 54788",
    d: "M361.319,281.859a2.069,2.069,0,0,1,.747-1.624,2.815,2.815,0,0,1,1.867-.635h1.549v2.427h-.952q-.784.028-.784.728v.541h1.717v2.5h-1.717v7.392H361.3l.019-11.331Z",
    transform: "translate(-297.647 -277.92)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54789",
    "data-name": "Path 54789",
    d: "M393.864,305.752v.168a.651.651,0,0,0,.168.467.353.353,0,0,0,.317.224h5v2.5h-5.32a4.431,4.431,0,0,1-1.139-.131,2.089,2.089,0,0,1-.784-.467,2.164,2.164,0,0,1-.541-.821,3.87,3.87,0,0,1-.149-1.157l-.019-5.021a2.129,2.129,0,0,1,2.371-2.315h3.285a2.126,2.126,0,0,1,2.315,2.389v1.979Zm3.043-3.528v-.056a.367.367,0,0,0-.168-.317.774.774,0,0,0-.429-.112h-1.7a.8.8,0,0,0-.541.187.525.525,0,0,0-.261.448v1.008Z",
    transform: "translate(-322.128 -293.861)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54790",
    "data-name": "Path 54790",
    d: "M449.34,309.131a5.45,5.45,0,0,1-1.008-.093,2.014,2.014,0,0,1-.952-.448,2.455,2.455,0,0,1-.709-.971,3.453,3.453,0,0,1-.187-1.213v-4.667a3.4,3.4,0,0,1,.112-1.008,1.86,1.86,0,0,1,.523-.84,2.153,2.153,0,0,1,.915-.579,4.489,4.489,0,0,1,1.045-.112h3.752v.579h-3.64a2.515,2.515,0,0,0-1.512.392,1.794,1.794,0,0,0-.579,1.493v4.667a3.273,3.273,0,0,0,.149.952,1.77,1.77,0,0,0,.523.8,2.3,2.3,0,0,0,.784.373,4.325,4.325,0,0,0,.859.075h3.491v.579l-3.565.019Z",
    transform: "translate(-366.927 -293.861)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54791",
    "data-name": "Path 54791",
    d: "M500.352,306.017a7.383,7.383,0,0,1-.075.989,2.3,2.3,0,0,1-.485.915,2.4,2.4,0,0,1-1.9.784h-2.912a2.552,2.552,0,0,1-1.848-.691,2.391,2.391,0,0,1-.728-1.848v-1.512a2.34,2.34,0,0,1,2.539-2.613h4.853v-.672a2.407,2.407,0,0,0-.467-1.437,1.515,1.515,0,0,0-.709-.541,4.54,4.54,0,0,0-.915-.112h-5.3V298.7h5.021a8.54,8.54,0,0,1,1.251.093,1.517,1.517,0,0,1,.541.224,1.8,1.8,0,0,1,.485.448,3.185,3.185,0,0,1,.672,2l-.019,4.555Zm-.6-3.36h-4.909a1.9,1.9,0,0,0-1.381.541,2.048,2.048,0,0,0-.5,1.475v1.493a3.5,3.5,0,0,0,.093.8,1.263,1.263,0,0,0,.448.672,2.143,2.143,0,0,0,1.4.523h2.968a1.719,1.719,0,0,0,1.867-1.979v-3.528Z",
    transform: "translate(-404.275 -293.455)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54792",
    "data-name": "Path 54792",
    d: "M553.071,299.679c-1.344.037-2.035.765-2,2.24v7.149H550.5v-7.149c-.037-1.867.859-2.819,2.688-2.819h.653v.579Z",
    transform: "translate(-451.525 -293.78)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54793",
    "data-name": "Path 54793",
    d: "M585.148,292.053c-.056,1.885-1.064,2.819-3.005,2.763h-2.165a5.968,5.968,0,0,1-1.213-.112,2.267,2.267,0,0,1-1.083-.691,2.107,2.107,0,0,1-.485-.952,4.017,4.017,0,0,1-.112-1.083V287.7c.037-1.923.989-2.875,2.893-2.856h4.573V281.6h.579l.018,10.453Zm-.578-6.608H579.94a3.365,3.365,0,0,0-.9.112,1.571,1.571,0,0,0-.821.5,1.693,1.693,0,0,0-.448.747,2.735,2.735,0,0,0-.112.915v4.555a1.63,1.63,0,0,0,.672,1.549,2.588,2.588,0,0,0,.728.3,4.527,4.527,0,0,0,.9.112h2.016a3.18,3.18,0,0,0,1.848-.523,2,2,0,0,0,.728-1.717l.019-6.552Z",
    transform: "translate(-473.148 -279.547)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24743",
    "data-name": "Group 24743",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54794",
    "data-name": "Path 54794",
    d: "M22.565,275.6a3.478,3.478,0,0,1,.579-.187,3.721,3.721,0,0,1,7.28,0,2.472,2.472,0,0,1,1.344.653,5.14,5.14,0,0,0-.037-.933,4.967,4.967,0,0,0-9.912.243c-.019.224-.019.467-.019.709A2.439,2.439,0,0,1,22.565,275.6Z",
    transform: "translate(-21.52 -270.6)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54795",
    "data-name": "Path 54795",
    d: "M28.439,299.4H22.5a2.27,2.27,0,0,0-.9.187,2.33,2.33,0,0,0-.728.467,3.064,3.064,0,0,0-.579,1.96v4.648a3.029,3.029,0,0,0,.579,1.96,2.57,2.57,0,0,0,.728.467,2.27,2.27,0,0,0,.9.187h5.955c1.531-.019,2.333-.859,2.352-2.52V301.9C30.772,300.24,29.988,299.419,28.439,299.4Z",
    transform: "translate(-20.3 -294.024)",
    fill: "#5c5c5c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaysafecard);
export default __webpack_public_path__ + "static/media/Logo_Paysafecard.27159f8eded64553fe944a6141b368ea.svg";
export { ForwardRef as ReactComponent };